import { InteractiveTable } from '@dreryk/react-components';

import {
   SurveyPreInterviewTemplateFormBean,
   SurveyPreInterviewTemplateFormController,
} from '../SurveyPreInterviewTemplateForm.types';

import { useSurveyPreInterviewTemplateInteractiveTableColumns } from './SurveyPreInterviewTemplateInteractiveTable.hooks';
import { SurveyPreInterviewTemplateTableBean } from './SurveyPreInterviewTemplateInteractiveTable.types';
import { QuestionAddRowButton } from './buttons/QuestionAddRowButton';

const SURVEY_PRE_INTERVIEW_TEMPLATE_INTERACTIVE_TABLE_NAME = 'questions';

export type QuestionsFormBeanPart = {
   [SURVEY_PRE_INTERVIEW_TEMPLATE_INTERACTIVE_TABLE_NAME]: SurveyPreInterviewTemplateTableBean[];
};

type SurveyPreInterviewTemplateInteractiveTableProps = Pick<SurveyPreInterviewTemplateFormController, 'register'> & {
   readonly editMode: boolean;
};

export const SurveyPreInterviewTemplateInteractiveTable = (
   props: SurveyPreInterviewTemplateInteractiveTableProps
): JSX.Element => {
   return (
      <InteractiveTable<SurveyPreInterviewTemplateTableBean, SurveyPreInterviewTemplateFormBean>
         columns={useSurveyPreInterviewTemplateInteractiveTableColumns({
            editMode: props.editMode,
         })}
         name={SURVEY_PRE_INTERVIEW_TEMPLATE_INTERACTIVE_TABLE_NAME}
         register={props.register}
         testId={SURVEY_PRE_INTERVIEW_TEMPLATE_INTERACTIVE_TABLE_NAME}
      >
         {props.editMode ? <QuestionAddRowButton /> : null}
      </InteractiveTable>
   );
};
